import React from 'react';

const TabAccordion = ({
  children,
  index,
  selectedTab,
  headerIcon,
  headerName,
  switchActiveTab
}) => {
  const childrenNodes = Array.isArray(children) ? children : [children];

  const isTabActive = index === selectedTab;
  const activeTabClass = isTabActive ? 'active-accordion-tab' : '';
  const iconClass = isTabActive ? 'fa-chevron-up' : 'fa-chevron-down';

  return (
    <div className="tab-accordion-wrapper">
      <div
        className={`accordion-header ${activeTabClass}`}
        onClick={e => {
          e.persist();
          switchActiveTab(index);
        }}
      >
        {headerIcon && <i className={`fa accordion-icon ${headerIcon}`} />}
        {headerName && <span className="header-name">{headerName}</span>}
        <i className={`dropdown-icon fa ${iconClass}`} />
      </div>
      {childrenNodes.map((elem, i) => {
        return (
          <elem.type
            {...elem.props}
            key={`accordion-tab-${i}`}
            className={activeTabClass}
          />
        );
      })}
    </div>
  );
};

export default TabAccordion;



// WEBPACK FOOTER //
// ./app/javascript/common/components/accordion.jsx